import(/* webpackMode: "eager" */ "/app/apps/storefront/src/app/global-error.tsx");
